// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGPan2ActiveIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGPan2ActiveIcon extends PureComponent<
  ISVGPan2ActiveIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        fontSize={size || 45}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="45px"
        height="45px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 45 45"
      >
        <path
          fill="#10a4e1"
          stroke="#ffffff"
          strokeMiterlimit="10"
          d="M19.982,8.736c0,2.716,0,5.434,0,8.148c2.666,0,5.336,0,8.004,0
		c-0.006-0.801-0.01-1.711,0.072-2.4c0.223-0.15,0.213-0.251,0.582-0.291c0.409-0.216,1.153,0.66,1.452,0.873
		c1.47,1.04,3.08,1.974,4.367,3.202c0,0.168,0,0.34,0,0.508c-1.342,1.261-2.976,2.295-4.513,3.347
		c-0.323,0.223-0.983,1.11-1.6,0.729c-0.553-0.344-0.379-1.807-0.363-2.691c-2.668,0-5.338,0-8.004,0c0,2.668,0,5.336,0,8.004
		c0.871-0.012,1.894-0.022,2.547,0.146c0.465,0.965-0.336,1.461-0.803,2.108c-1.022,1.426-1.928,2.967-3.127,4.222
		c-0.147,0-0.292,0-0.438,0c-1.187-1.188-2.064-2.69-3.055-4.074c-0.431-0.603-1.071-0.955-1.091-1.967
		c0.058-0.072,0.025-0.019,0.072-0.146c0.127-0.078,0.263-0.182,0.364-0.289c0.776,0,1.551,0,2.329,0c0-2.668,0-5.336,0-8.004
		c-2.74,0-5.481,0-8.222,0c0.026,0.832,0.206,2.348-0.365,2.621c-0.139,0.129-0.229,0.137-0.508,0.145
		c-1.786-1.489-3.925-2.559-5.601-4.147c0-0.17,0-0.34,0-0.51c1.166-1.072,2.551-1.903,3.855-2.836
		c0.699-0.501,1.233-1.271,2.255-1.237c0.456,0.693,0.377,1.53,0.365,2.692c2.74,0,5.48,0,8.222,0c0-2.716,0-5.433,0-8.148
		c-0.88,0.011-1.878,0.01-2.547-0.146c-0.062-0.105-0.131-0.208-0.217-0.291c-0.005-1.075,0.778-1.543,1.236-2.183
		c0.934-1.298,1.757-2.702,2.837-3.855c0.17,0,0.338,0,0.51,0c1.127,1.209,2.393,2.257,3.366,3.621
		C22.49,6.621,22.87,7.404,22.6,8.521C21.941,8.718,20.943,8.739,19.982,8.736z"
        />
        <path
          fill="#10a4e1"
          stroke="#ffffff"
          strokeMiterlimit="10"
          d="M18.53,6.722c0,2.716,0,5.434,0,8.148c2.667,0,5.337,0,8.005,0
		c-0.006-0.801-0.01-1.711,0.072-2.4c0.223-0.15,0.213-0.251,0.582-0.291c0.41-0.216,1.154,0.66,1.453,0.873
		c1.469,1.04,3.08,1.974,4.367,3.202c0,0.169,0,0.34,0,0.508c-1.342,1.26-2.977,2.295-4.514,3.346
		c-0.322,0.223-0.982,1.111-1.6,0.729c-0.553-0.344-0.379-1.807-0.363-2.691c-2.668,0-5.338,0-8.004,0c0,2.668,0,5.337,0,8.005
		c0.871-0.013,1.895-0.022,2.547,0.146c0.467,0.965-0.336,1.461-0.803,2.108c-1.021,1.426-1.929,2.967-3.128,4.221
		c-0.146,0-0.291,0-0.438,0c-1.187-1.188-2.064-2.69-3.055-4.073c-0.431-0.603-1.071-0.955-1.091-1.968
		c0.058-0.071,0.025-0.018,0.072-0.146c0.127-0.077,0.263-0.182,0.364-0.288c0.776,0,1.551,0,2.329,0c0-2.668,0-5.337,0-8.005
		c-2.74,0-5.481,0-8.222,0c0.026,0.832,0.206,2.349-0.365,2.621C6.6,20.896,6.51,20.904,6.231,20.912
		c-1.786-1.489-3.925-2.56-5.601-4.148c0-0.17,0-0.34,0-0.51c1.166-1.071,2.551-1.902,3.855-2.836
		c0.699-0.501,1.233-1.271,2.255-1.237c0.456,0.693,0.377,1.53,0.365,2.692c2.74,0,5.48,0,8.222,0c0-2.716,0-5.433,0-8.148
		c-0.88,0.011-1.878,0.01-2.547-0.146c-0.062-0.105-0.131-0.208-0.217-0.291c-0.005-1.075,0.778-1.543,1.236-2.183
		c0.934-1.298,1.757-2.702,2.837-3.855c0.17,0,0.338,0,0.51,0c1.126,1.209,2.008,2.638,2.982,4.001
		c0.525,0.735,1.291,1.138,1.02,2.255C20.49,6.703,19.492,6.725,18.53,6.722z"
        />
        <g id="Layer_2" display="none">
          <line
            display="inline"
            fill="none"
            stroke="#010101"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            x1="7.224"
            y1="18.5"
            x2="9.099"
            y2="20.521"
          />

          <line
            display="inline"
            fill="none"
            stroke="#010101"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            x1="0.75"
            y1="17.117"
            x2="2.625"
            y2="19.139"
          />

          <line
            display="inline"
            fill="none"
            stroke="#010101"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            x1="6.86"
            y1="12.535"
            x2="8.735"
            y2="14.556"
          />

          <line
            display="inline"
            fill="none"
            stroke="#010101"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            x1="18.646"
            y1="18.5"
            x2="20.521"
            y2="20.521"
          />

          <line
            display="inline"
            fill="none"
            stroke="#010101"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            x1="21.193"
            y1="26.648"
            x2="23.068"
            y2="28.67"
          />

          <line
            display="inline"
            fill="none"
            stroke="#010101"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            x1="17.264"
            y1="32.979"
            x2="18.702"
            y2="35"
          />

          <line
            display="inline"
            fill="none"
            stroke="#010101"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            x1="27.016"
            y1="21.191"
            x2="28.891"
            y2="23.214"
          />

          <line
            display="inline"
            fill="none"
            stroke="#010101"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            x1="33.125"
            y1="16.609"
            x2="35"
            y2="18.631"
          />

          <line
            display="inline"
            fill="none"
            stroke="#010101"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            x1="12.9"
            y1="6.933"
            x2="14.558"
            y2="8.664"
          />

          <line
            display="inline"
            fill="none"
            stroke="#010101"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            x1="21.268"
            y1="6.86"
            x2="23.143"
            y2="8.882"
          />

          <line
            display="inline"
            fill="none"
            stroke="#010101"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            x1="17.266"
            y1="0.604"
            x2="19.141"
            y2="2.625"
          />

          <line
            display="inline"
            fill="none"
            stroke="#010101"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            x1="18.646"
            y1="7.077"
            x2="20.521"
            y2="9.099"
          />

          <line
            display="inline"
            fill="none"
            stroke="#010101"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            x1="6.859"
            y1="21.121"
            x2="8.734"
            y2="23.143"
          />

          <line
            fill="none"
            stroke="#FEFEFE"
            strokeMiterlimit="10"
            x1="0.63"
            y1="16.764"
            x2="2.082"
            y2="18.778"
          />
          <line
            fill="none"
            stroke="#FEFEFE"
            strokeMiterlimit="10"
            x1="6.739"
            y1="20.767"
            x2="8.191"
            y2="22.781"
          />
          <line
            fill="none"
            stroke="#FEFEFE"
            strokeMiterlimit="10"
            x1="6.74"
            y1="12.181"
            x2="8.192"
            y2="14.195"
          />
          <line
            fill="none"
            stroke="#FEFEFE"
            strokeMiterlimit="10"
            x1="7.104"
            y1="18.146"
            x2="8.556"
            y2="20.16"
          />
          <line
            fill="none"
            stroke="#FEFEFE"
            strokeMiterlimit="10"
            x1="18.529"
            y1="18.146"
            x2="19.98"
            y2="20.16"
          />
          <line
            fill="none"
            stroke="#FEFEFE"
            strokeMiterlimit="10"
            x1="17.146"
            y1="32.625"
            x2="18.159"
            y2="34.64"
          />
          <line
            fill="none"
            stroke="#FEFEFE"
            strokeMiterlimit="10"
            x1="21.076"
            y1="26.296"
            x2="22.527"
            y2="28.31"
          />
          <line
            fill="none"
            stroke="#FEFEFE"
            strokeMiterlimit="10"
            x1="26.896"
            y1="20.837"
            x2="28.348"
            y2="22.852"
          />
          <line
            fill="none"
            stroke="#FEFEFE"
            strokeMiterlimit="10"
            x1="33.01"
            y1="16.254"
            x2="34.46"
            y2="18.269"
          />
          <line
            fill="none"
            stroke="#FEFEFE"
            strokeMiterlimit="10"
            x1="18.53"
            y1="6.722"
            x2="19.982"
            y2="8.736"
          />
          <line
            fill="none"
            stroke="#FEFEFE"
            strokeMiterlimit="10"
            x1="12.78"
            y1="6.579"
            x2="14.015"
            y2="8.302"
          />
          <line
            fill="none"
            stroke="#FEFEFE"
            strokeMiterlimit="10"
            x1="21.148"
            y1="6.506"
            x2="22.6"
            y2="8.521"
          />
        </g>
      </svg>
    );
  }
}
